import React from 'react';
import enhance from './enhance';
import OrderSeries from '../OrderSeries';
import AllocationSummary from '../../AllocationSummary';
import AnnouncementAlert from '../../Announcement/AnnouncementAlert';
import Header from '../../Layout/Header';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { announcementsPath } from 'utils/paths';
import styles from './styles.module.scss';
import Loading from 'components/Loading';

export const OrderDashboard = ({
  hasQuotaDetail,
  selectedSeriesId,
  redirectToAnnouncements,
  hasNewAnnouncements,
  unreadMessagesCount,
  mini,
  announcementsLoading,
}) =>
  announcementsLoading ? (
    <Loading />
  ) : redirectToAnnouncements ? (
    <Redirect
      to={{
        pathname: announcementsPath,
      }}
    />
  ) : (
    <div
      className={
        mini
          ? styles.orderMiniDashboardContainer
          : styles.orderDashboardContainer
      }
    >
      <Header />
      {hasNewAnnouncements && <AnnouncementAlert count={unreadMessagesCount} />}
      <AllocationSummary />
      <OrderSeries
        hasQuotaDetail={hasQuotaDetail}
        selectedSeriesId={selectedSeriesId}
      />
    </div>
  );

OrderDashboard.propTypes = {
  hasQuotaDetail: PropTypes.bool.isRequired,
  selectedSeriesId: PropTypes.string,
};

export default enhance(OrderDashboard);
